import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import DocumentCreationButton from 'Components/DocumentCreationButton';
import HistorySection from 'Components/HistorySection';
import type { IHistoryContext } from 'Containers/FormContextHandler';
import { withHistoryContext } from 'Containers/FormContextHandler';
import type { RelevantDocumentType } from '../definitions';
import { TreatmentHistorySection } from './components';

const DEFAULT_DOCUMENTS: IDocumentWithTypeV2<RelevantDocumentType>[] = [];
const OtherTreatment = ({
  documents = DEFAULT_DOCUMENTS,
  startEdit,
  view,
}: IHistoryContext<IDocumentWithTypeV2<RelevantDocumentType>>): React.JSX.Element => (
  <HistorySection
    headerText={<FormattedMessage id="treatment.otherTreatment.title" />}
    newButton={
      startEdit ? (
        <DocumentCreationButton
          name="otherTreatment"
          text="treatment.otherTreatment.newOtherTreatment"
          onClick={startEdit({}, 'otherTreatment')}
          asyncOnClick={undefined}
          width={15}
          height={3}
          fontSize={14}
          alternate={true}
        />
      ) : (
        <></>
      )
    }
  >
    <TreatmentHistorySection documents={documents} startEdit={startEdit} type="otherTreatment" view={view} />
  </HistorySection>
);

export default withHistoryContext(OtherTreatment);
